import { render, staticRenderFns } from "./milestone-overview.view.vue?vue&type=template&id=4d06a629&scoped=true&"
import script from "./milestone-overview.view.vue?vue&type=script&lang=ts&"
export * from "./milestone-overview.view.vue?vue&type=script&lang=ts&"
import style0 from "./milestone-overview.view.vue?vue&type=style&index=0&id=4d06a629&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d06a629",
  null
  
)

export default component.exports